var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow_across_last_item"},[_c('a',{staticClass:"navLink",attrs:{"href":_vm.url,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.linkText))]),_c('fas-icon',{staticClass:"fa external-link-icon",attrs:{"icon":_vm.appIcons.externalLink}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }